module.exports = __webpack_public_path__ + "img/house.a98a8a53.png";